import { useCallback } from "react";
import { POLICIES_POLICY_VALUE_DOWNLOAD } from "../../../constants/policies";
import useCanPerform from "../../../hooks/useCanPerform";
import useDownloadFile from "../../../hooks/useDownloadFile";
import generateApiUri from "../../../libraries/utils/generateApiUri";

export function useDocumentsActionDownload({ resource }) {
  const canPerform = useCanPerform();

  return {
    isAllowed: canPerform({
      policies: POLICIES_POLICY_VALUE_DOWNLOAD,
      resourcePolicies: resource?.meta?.policies,
    }),
  };
}

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Document").Document} document
 * @property {(props: { isAllowed: boolean, trigger: () => void, isLoading: boolean }) => import("react").ReactElement | null} render
 *
 * @param {Props} props
 */
function DocumentsActionDownload({ document, render }) {
  const { isAllowed } = useDocumentsActionDownload({ resource: document });

  const { download, isLoading } = useDownloadFile({
    mode: "preview",
  });

  const trigger = useCallback(() => {
    download(
      generateApiUri({
        id: "@documents.download",
        parameters: {
          documentId: document.id,
        },
      }),
    );
  }, [document.id, download]);

  return render({
    isAllowed,
    trigger,
    isLoading,
  });
}

export default DocumentsActionDownload;
